module.exports = __webpack_public_path__ + "img/join3-1.66c8b927.svg";